import React from 'react';
import { FormData, Formula } from '../types';
import { FormulaCard } from '../../../components/FormulaCard';

interface FormulaSectionProps {
  formData: FormData;
  formulas: Formula[];
  loading: boolean;
  error: string | null;
  updateFormData: (field: keyof FormData, value: string) => void;
  validationErrors?: { [key: string]: string };
}

export const FormulaSection: React.FC<FormulaSectionProps> = ({
  formData,
  formulas,
  loading,
  error,
  updateFormData,
  validationErrors = {}
}) => (
  <fieldset>
    <legend className="font-display text-lg font-bold">Welke formule past bij je feest?</legend>
    <p className="mt-1 text-sm text-bl-black/60">Je kan dit later nog met ons bespreken. Alle burgers bestaan ook in een vegetarische versie.</p>

    {loading && <p className="mt-6 text-sm text-bl-black/55">Formules laden…</p>}
    {error && <p className="field-message">{error}</p>}

    <div className="mt-6 grid grid-cols-1 gap-5 pt-2 md:grid-cols-2">
      {formulas.map((formula) => {
        const selected = formData.formula === formula.slug;
        return (
          <label key={formula.id} className="block cursor-pointer">
            <input
              type="radio"
              name="formula"
              value={formula.slug}
              checked={selected}
              onChange={(e) => updateFormData('formula', e.target.value)}
              className="peer sr-only"
            />
            <div className="h-full rounded-lg peer-focus-visible:ring-2 peer-focus-visible:ring-bl-gold peer-focus-visible:ring-offset-2">
              <FormulaCard formula={formula} selected={selected} compact />
            </div>
          </label>
        );
      })}
    </div>

    {validationErrors.formula && <p className="field-message">{validationErrors.formula}</p>}
  </fieldset>
);
